import { render } from "./Login.vue?vue&type=template&id=1c28a124"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Account/Login.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c28a124"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c28a124', __exports__)) {
    api.reload('1c28a124', __exports__)
  }
  
  module.hot.accept("./Login.vue?vue&type=template&id=1c28a124", () => {
    api.rerender('1c28a124', render)
  })

}


export default __exports__